var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cavans-area",attrs:{"id":"cavansArea"}},[_c('canvas',{ref:"canvas",on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":_vm.mouseUp,"touchend":_vm.touchEnd,"touchmove":_vm.touchMove,"touchstart":_vm.touchStart}}),(!_vm.hasDrew)?_c('span',{class:_vm.classes},[_vm._v("签名区")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }